import { api, qs } from "./base";
import type { ListResponse } from "@/common/types";

export interface AuditEvent {
  auditId: string;
  ts: number;
  timestamp: string; // ISO-8601
  action: string; // REPO_ONBOARDED | REPO_UPDATED | REPO_DISABLED | REPO_ENABLED | REPO_OFFBOARDED | EXCEPTION_*
  actor: string;
  resourceId: string; // the repo
  resourceType?: string;
  /** Before→after diff: {field: {from, to}} for config writes (onboard/update/offboard). */
  changes?: Record<string, { from?: unknown; to?: unknown } | unknown>;
  detail?: Record<string, unknown>;
}

/** Audit activity, newest-first. Omit `repo` for the global feed. */
export function listAudit(
  params: { repo?: string; limit?: number } = {},
): Promise<ListResponse<AuditEvent>> {
  return api.get<ListResponse<AuditEvent>>(
    `/audit${qs({ repo: params.repo, limit: params.limit ? String(params.limit) : undefined })}`,
  );
}
